import { ThemeOptions } from "@mui/material/styles";

import { createTheme } from "@mui/material";

export const themeOptions = {
  palette: {
    type: "light",
    primary: {
      main: "#2C633C ",
      contrastText: "#fff",
    },
    secondary: {
      main: "#06623b",
    },
  },
  components: {
    MuiIconButton: {
      styleOverrides: {
        // Name of the slot
        // root: {
        //   backgroundColor: "#2C633C",
        //   color: "white ",
        //   border: "1px solid transparent",
        //   "&:hover": {
        //     backgroundColor: "white",
        //     color: "#2C633C ",
        //     border: "1px solid #2C633C ",
        //   },
        // },
      },
    },
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        // root: {
        //   backgroundColor: "#2C633C",
        //   color: "white ",
        //   border: "1px solid transparent",
        //   "&:hover": {
        //     backgroundColor: "white",
        //     color: "#2C633C ",
        //     border: "1px solid #2C633C ",
        //   },
        // },
      },
    },
   
    MuiOutlinedInput: {
      styleOverrides: {
        // Name of the slot
        root: {
         
          "& input": {
            padding: "7.5px",
          },
          "&  > div": {
            padding: "7.5px",
          },
          borderRadius: "5px !important",
          // "&:hover":{
          //   backgroundColor :"white",
          //   color: "#2C633C !important",
          //   border: "1px solid #2C633C !important",
          //   borderRadius: "5px !important",
          // }
        },
      },
    },
  },
  props: {
    MuiTooltip: {
      arrow: true,
    },
    MuiAppBar: {
      color: "default",
    },
  },
  overrides: {
    MuiSwitch: {
      root: {
        width: 42,
        height: 26,
        padding: 0,
        margin: 8,
      },
      switchBase: {
        padding: 1,
        "&$checked, &$colorPrimary$checked, &$colorSecondary$checked": {
          transform: "translateX(16px)",
          color: "#fff",
          "& + $track": {
            opacity: 1,
            border: "none",
          },
        },
      },
      thumb: {
        width: 24,
        height: 24,
      },
      track: {
        borderRadius: 13,
        border: "1px solid #bdbdbd",
        backgroundColor: "#fafafa",
        opacity: 1,
        transition:
          "background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      },
    },
    MuiButton: {
      variants: [
        {
          props: { variant: "contained" },
          style: {
            textTransform: "none",
            border: `none`,
            padding: 150,
          },
        },
      ],
    },
    MuiInput:{
      // styleOverrides:{

        root:{
          display: "none !important"
          
        }
      // }
    }
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily: "Montserrat",
  },
  iconBtn: {
    // primary: {
    //   backgroundColor: "#2C633C",
    //   color: "white ",
    // },
  },
};

export const theming = createTheme({
  status: {
    green: "#2C633C",
  },
});
